import "../../../static/js/loaders/jquery"
$(".block-container-wrapper").on("show.bs.collapse", function () {
	$(this).closest(".block-container-block").addClass("expanded");

});
$(".block-container-wrapper").on("hide.bs.collapse", function () {
	$(this).closest(".block-container-block").removeClass("expanded");
});